import { useEffect } from "react";
import { createContext, useReducer, useState } from "react";




export const Userauthcontext = createContext() // for User


export const Userauthreducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload, expiryTime: action.payload.expiryTime, }
        case 'LOGOUT':
            return { user: null, expiryTime: null }
        default:
            return state;
    }
}



export const UserAuthContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(Userauthreducer, {
        user: null,
        expiryTime: null,
    })
    const [Authloading, setLoading] = useState(true); // Add a loading state



    useEffect(() => {

        const token = localStorage.getItem("user");
        const expiryTime = localStorage.getItem("expiryTime");

        if (token && expiryTime) {

            const now = Date.now();

            // Session expired
            if (now >= Number(expiryTime)) {

                localStorage.removeItem("user");
                localStorage.removeItem("expiryTime");

                dispatch({
                    type: "LOGOUT",
                });

            } else {

                dispatch({
                    type: "LOGIN",
                    payload: {
                        token,
                        expiryTime: Number(expiryTime),
                    },
                });

            }

        }

        setLoading(false);

    }, []);

    return (
        <Userauthcontext.Provider
            value={{
                ...state,
                dispatch,
                Authloading,
            }}
        >
            {children}
        </Userauthcontext.Provider>
    );


    // useEffect(() => {
    //     // Safely parse the user data
    //     const userData = localStorage.getItem('user');
    //     const expiryTime = localStorage.getItem("expiryTime");
    //     // if (userData) {
    //     //     dispatch({ type: 'LOGIN', payload: userData });
    //     // }
    //     if (userData) {
    //         try {
    //             const parsedUser = userData;
    //             dispatch({ type: "LOGIN", payload: parsedUser });
    //         } catch (error) {
    //             console.error("Failed to parse user data from localStorage:", error);
    //         }
    //     }
    //     setLoading(false); // Finish initialization
    // }, [])

    //console.log('AuthContext State: ', state);

    // return (
    //     <Userauthcontext.Provider value={{ ...state, dispatch, Authloading}}>
    //         {children}
    //     </Userauthcontext.Provider>
    // )
}